import React, {useEffect, useState} from 'react';

import {ServerResponseHandler} from 'src/components/server-response-handler';
import {NotificationContent} from 'src/modules/internal-notification/components/notification-content';
import {fetchNotification} from 'src/openapi/admin/apis/InternalNotificationApi';
import {useAppDispatch} from 'src/store/hooks';

import {Item} from '@pb/kit-component-group';
import Typography from '@pb/kit-component-typography';

import {ContentLoader} from '../content/content-loader';

import type {Notification} from 'src/openapi/admin/models/Notification';
import type {ServerResponse} from 'src/typedef';


type Props = {
    notificationId: string,
};

export const UserNotificationsContent = ({notificationId}: Props) => {
    const apiDispatch = useAppDispatch();
    const [isLoading, setLoading] = useState<boolean>(false);
    const [response, setResponse] = useState<ServerResponse<Notification> | null>(null);

    useEffect(() => {
        const loadNotification = async () => {
            setLoading(true);
            const apiResponse = await apiDispatch(fetchNotification({notificationId}));
            setLoading(false);

            if (apiResponse.payload.success) {
                setResponse({data: apiResponse.payload.data});
            } else {
                setResponse({error: apiResponse.payload.data});
            }
        };

        loadNotification();
    }, [notificationId, apiDispatch]);

    if (isLoading) {
        return <ContentLoader/>;
    }

    return (
        <ServerResponseHandler serverError={response?.error || null}>
            <Item grow={1}>
                <div className="pdx-l pdy-m">
                    <Typography fontWeight="semi-bold" variant="heading-level-3">
                        {response?.data?.title || ''}
                    </Typography>
                </div>
                <div className="pd-m">
                    <NotificationContent
                        width="100%"
                        maxHeight="100%"
                        content={response?.data?.content || ''}
                    />
                </div>
            </Item>
        </ServerResponseHandler>
    );
};

